import Gallery from 'blueimp-gallery'

function showGallery(galleryImages, event){
    let target = event.target || event.srcElement

    let options = { index: galleryImages.indexOf(target.src || target.href), event: event }

    Gallery(galleryImages, options)
}

function addEventToAttachment(el, galleryImages, addToGallery) {
    let title = el.title?.toLowerCase()

    if (!title || title.endsWith('.jpg') || title.endsWith('.png') || title.endsWith('.jpeg')) {
        if (addToGallery) {
            galleryImages.push(el.src || el.href)
        }

        el.addEventListener('click', function(event) {
            event.preventDefault()
            showGallery(galleryImages, event)
        })
    }
}

/**
 * @param {HTMLImageElement} img
 */
function isImageHidden(img) {
    return img.clientWidth === 0
}

export function initGalleryTicket() {
    let firstMessageImages = document.querySelectorAll('.tab-content-call-info .observation.mce-content-body img')

    let messageImages = document.querySelectorAll('.card-attendance .observation img')

    let messageFiles = document.querySelectorAll('.container-files a.attachment-image')

    let allFiles = document.querySelectorAll('.table-container-files a.attachment-image')

    let galleryImages = []

    messageImages.forEach(el => {
        if (!isImageHidden(el)) {
            addEventToAttachment(el, galleryImages, true)
        }
    })

    messageFiles.forEach(el => {
        addEventToAttachment(el, galleryImages, true)
    })

    firstMessageImages.forEach(el => {
        addEventToAttachment(el, galleryImages, false)
    })

    allFiles.forEach(el => {
        addEventToAttachment(el, galleryImages, false)
    })
}

export function initGallery() {
    let listImgs = document.querySelectorAll('.gallery-images img')

    let galleryImages = []

    listImgs.forEach(el => {
        galleryImages.push(el.src)

        el.addEventListener('click', function(event) {
            showGallery(galleryImages, event)
        })
    })
}
